export default {
  outList: [
    {
      light_point_1:[
        {
          title: '自然之美',
          type: 'image',
          video: '',
          image: 'lightPoint/1/1.jpg',
          text: '虎踞前脸，齿锋点阵格栅'
        },
      ],
      light_point_2:[
        {
          title: '大灯造型',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '灵眸LED日行灯'
        },
      ],
      light_point_3:[
        {
          title: '磐石车身',
          type: 'image',
          video: '',
          image: 'lightPoint/5/1.jpg',
          text: '80%高强度钢铝占比，硬核守护家人安全'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '15.6吋2.5K高清电影屏',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: '看得更真，看得更清，看得更全'
        },
      ],
      light_point_2:[
        {
          title: '970mm后排腿部空间',
          type: 'image',
          video: '',
          image: 'lightPoint/3/4.jpg',
          text: '84%空间得房率，容得下全家舒享'
        }
      ],
      light_point_3:[
        {
          title: '电感沙滩椅模式',
          type: 'image',
          video: '',
          image: 'lightPoint/3/3.jpg',
          text: '前排座椅靠背向后170°放平，怎么躺都行'
        }
      ],
      light_point_4:[
        {
          title: '11个全场景“神奇挂钩',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '让物品安置井然有序，便利好用'
        },
      ],
      light_point_5:[
        {
          title: '50W无线快充',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '随手一放，快速满格'
        },
      ]
    }
  ],
  tab1:[
    {
      title: '虎踞前脸',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '齿锋点阵格栅'
    },
    {
      title: '座舱造型',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '晨曦山林环抱式座舱'
    },
    {
      title: '车身造型',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '猎影车身'
    },
    {
      title: '大灯造型',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '灵眸LED日行灯'
    }
  ],
  tab2: [
    {
      title: '全系标配车规级8155芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '毫秒级响应畅快出行'
    },
    {
      title: '15.6吋2.5K高清电影屏',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '看得更真，看得更清，看得更全'
    },
    {
      title: '50W无线快充',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '随手一放，快速满格'
    },
  ],
  tab3: [
    {
      title: '11个全场景“神奇挂钩”',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '让物品安置井然有序，便利好用'
    },
    {
      title: '全场景小桌板',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '高端MPV商务车配置，适配多种场景'
    },
    {
      title: '电感沙滩椅模式',
      type: 'image',
      video: '',
      image: 'lightPoint/3/3.jpg',
      text: '前排座椅靠背向后170°放平，怎么躺都行'
    },
    {
      title: '970mm后排腿部空间',
      type: 'image',
      video: '',
      image: 'lightPoint/3/4.jpg',
      text: '84%空间得房率，容得下全家舒享'
    }
  ],
  tab4: [
    {
      title: '新一代鲲鹏动力1.6TGDI发动机',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '全栈自研“中国心”十佳发动机'
    },
    {
      title: '7DCT双离合自动变速器',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '85%世界十佳变速箱'
    }
  ],
  tab5: [
    {
      title: '「磐石」车身',
      type: 'image',
      video: '',
      image: 'lightPoint/5/1.jpg',
      text: '80%高强度钢铝占比，硬核守护家人安全'
    },
  ]
}
